import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Input from '@components/form/Input';

export default function SaveTemplateModal({
	show,
	onHide,
	activeTemplate,
	filterName,
	onSave,
	isPending,
}) {
	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				<Modal.Title>{activeTemplate ? 'Update template' : 'Save as template'}</Modal.Title>
			</Modal.Header>
			<form
				onSubmit={e => {
					e.preventDefault();
					if (isPending) return;
					const formData = new FormData(e.target);
					onSave({ title: formData.get('title') });
				}}>
				<Modal.Body>
					<Input
						label="Template name"
						name="title"
						type="text"
						defaultValue={activeTemplate?.title || filterName || ''}
						placeholder="Enter template name"
						required
					/>
					<p className="text-muted small mt-2">
						The filter configuration will be saved and can be reused later.
					</p>
				</Modal.Body>
				<Modal.Footer>
					<Button type="button" variant="secondary" onClick={onHide}>
						Cancel
					</Button>
					<Button variant="success" type="submit" disabled={isPending}>
						{isPending ? 'Saving...' : 'Save'}
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	);
}
